var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-select", {
    attrs: {
      value: _setup.props.value,
      disabled: _vm.disabled,
      items: [
        {
          value: _vm.priceId,
          text: "Return to the current price",
        },
        {
          value: null,
          text: `Update to membership's full price`,
        },
      ],
      dense: "",
      outlined: "",
      "hide-details": "auto",
      label: "When this discount expires",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }